// extracted by mini-css-extract-plugin
module.exports = {"loader":"DotCircleSpinner_loader__1jv5M","load5":"DotCircleSpinner_load5__20XrV"};